import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IErrorFeedbackProps {
  message: string;
}

const ErrorFeedback = (props: IErrorFeedbackProps) => {
  const { message } = props;

  return (
    <p className="absolute bottom-[-16px] text-xs text-red-700 m-0">
      <FontAwesomeIcon icon={faExclamationTriangle} /> {message}
    </p>
  );
};

export default ErrorFeedback;
